import type { TranslationsFileLoader } from "./loadTranslations";

export default function groupTranslationImportsByLocale(
  importMap: {
    [pathname: string]: () => Promise<Matice.Translations>;
  },
  translationsRoot = "locales",
) {
  const translationFileLoaderMap = {} as {
    [locale: string]: TranslationsFileLoader[];
  };
  for (const [pathname, loader] of Object.entries(importMap)) {
    const parts = pathname.split("/");
    let offset = 0;
    while (parts[offset]?.startsWith(".")) {
      offset++;
    }
    if (parts[offset] === translationsRoot) {
      offset++;
    }
    parts[parts.length - 1] = parts[parts.length - 1].split(".")[0];
    const locale = parts[offset];
    const prefix = parts.slice(offset + 1);
    if (!translationFileLoaderMap[locale]) {
      translationFileLoaderMap[locale] = [];
    }
    if (prefix.at(-1) === "index") {
      prefix.pop();
    }
    translationFileLoaderMap[locale].push({ prefix, loader });
  }
  return translationFileLoaderMap;
}
